import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { PageHeader } from '@/components/shared/PageHeader';
import { DataTablePagination } from '@/components/shared';
import { WebhookDeliveryTable } from '@/components/features/webhook-deliveries/WebhookDeliveryTable';
import { WebhookDeliveryFilters } from '@/components/features/webhook-deliveries/WebhookDeliveryFilters';
import { WebhookDeliveryDetailsDialog } from '@/components/features/webhook-deliveries/WebhookDeliveryDetailsDialog';
import { useWebhookDeliveries } from '@/lib/hooks';
import type {
  WebhookDelivery,
  WebhookDeliveryFilters as WebhookDeliveryFiltersType,
} from '@/lib/types';

export const Route = createFileRoute('/_auth/_admin/admin/webhook-deliveries/')(
  {
    component: WebhookDeliveriesComponent,
  },
);

function WebhookDeliveriesComponent() {
  const [filters, setFilters] = useState<WebhookDeliveryFiltersType>({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [selected, setSelected] = useState<WebhookDelivery | null>(null);

  const { data, isLoading } = useWebhookDeliveries({
    ...filters,
    page,
    per_page: perPage,
    from_date: filters.from_date,
    to_date: filters.to_date,
  });

  const handleFiltersChange = (next: WebhookDeliveryFiltersType) => {
    setFilters(next);
    setPage(1);
  };

  return (
    <div className="space-y-6">
      <PageHeader title="Вебхуки" description="Журнал доставки вебхуков" />

      <WebhookDeliveryFilters
        filters={filters}
        onFiltersChange={handleFiltersChange}
      />

      <WebhookDeliveryTable
        data={data?.data || []}
        isLoading={isLoading}
        onRowClick={setSelected}
      />

      {data?.meta && (
        <DataTablePagination
          meta={data.meta}
          onPageChange={setPage}
          onPerPageChange={setPerPage}
        />
      )}

      <WebhookDeliveryDetailsDialog
        deliveryId={selected?.id ?? null}
        open={selected !== null}
        onOpenChange={(open) => {
          if (!open) setSelected(null);
        }}
      />
    </div>
  );
}
